import { NgModule } from '@angular/core';
import { PreloadingStrategy, RouterModule, Routes } from '@angular/router';
import { environment } from '@environment';
import { AuthorizedGuard, ProductConfigResolverService } from '@shared/core';
import { PageCabinetComponent } from './cabinet';
import { AppPreloadingStrategy } from '@cdk/router';

const devRoutes = [];
if (!environment.production) {
  devRoutes.push({
    path: 'ui-kit',
    canLoad: [AuthorizedGuard],
    loadChildren: () => import('./ui-kit/ui-kit.module').then(m => m.UiKitModule),
  });
}

const routes: Routes = [
  {
    path: '',
    component: PageCabinetComponent,
    canActivate: [AuthorizedGuard],
    canActivateChild: [AuthorizedGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'persons/tasks',
      },
      ...devRoutes,
      {
        path: 'persons',
        canLoad: [AuthorizedGuard],
        resolve: {
          productConfig: ProductConfigResolverService,
        },
        loadChildren: () => import('./crm/persons/persons.module').then(m => m.PersonsModule),
      },
      {
        path: 'companies',
        canLoad: [AuthorizedGuard],
        resolve: {
          productConfig: ProductConfigResolverService,
        },
        loadChildren: () => import('./companies/companies.module').then(m => m.CompaniesModule),
      },
      {
        path: 'admin',
        canLoad: [AuthorizedGuard],
        loadChildren: () => import('./crm/admin/admin.module').then(m => m.AdminModule),
      },
      {
        path: 'teachers',
        canLoad: [AuthorizedGuard],
        loadChildren: () => import('./crm/teachers/teachers.module').then(m => m.TeachersModule),
      },
      {
        path: 'customer-support',
        canLoad: [AuthorizedGuard],
        resolve: {
          productConfig: ProductConfigResolverService,
        },
        loadChildren: () => import('./customer-support/customer-support.module').then(m => m.CustomerSupportModule),
      },
      {
        path: 'teachers-schedule',
        canLoad: [AuthorizedGuard],
        resolve: {
          productConfig: ProductConfigResolverService,
        },
        loadChildren: () => import('./teachers-schedule/teachers-schedule.module').then(m => m.TeachersScheduleModule),
      },
      {
        path: 'group-schedule',
        canLoad: [AuthorizedGuard],
        resolve: {
          productConfig: ProductConfigResolverService,
        },
        loadChildren: () => import('./group-schedule/group-schedule.module').then(m => m.GroupScheduleModule),
      },
      {
        path: 'wfm',
        canLoad: [AuthorizedGuard],
        loadChildren: () => import('app/wfm/index').then(m => m.WfmModule),
      },
      {
        path: 'pds',
        canLoad: [AuthorizedGuard],
        loadChildren: () => import('./pds/pds.module').then(m => m.PdsModule),
      },
    ],
  },
  {
    path: 'user/:action',
    loadChildren: () => import('./cdk/auth-redirect/auth-redirect.module').then(m => m.AuthRedirectModule),
  },
  {
    path: 'not-found',
    loadChildren: () => import('./not-found/not-found.module').then(m => m.PageNotFoundModule),
  },
  {
    path: '**',
    redirectTo: '/not-found',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: AppPreloadingStrategy,
    }),
  ],
  exports: [RouterModule],
  providers: [{ provide: PreloadingStrategy, useClass: AppPreloadingStrategy }],
})
export class AppRoutingModule {}
